"use client";

import { IconEyeClose, IconEyeOpen } from "@repo/assets/images";
import cx from "classnames";
import { useState } from "react";

const InputPassword = ({
  value,
  label,
  name,
  placeholder,
  onChange,
  onBlur,
  readOnly,
  disabled,
  className,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-sm font-medium text-[#5E5E5E]"
        >
          {label}
        </label>
      )}
      <div className="relative flex grow items-center">
        <input
          id={name}
          type={isPasswordVisible ? "text" : "password"}
          readOnly={readOnly}
          disabled={disabled}
          value={value}
          name={name}
          onBlur={onBlur}
          placeholder={placeholder}
          onChange={onChange}
          className={cx(
            `focus:outline-icon-color border-supportiveDarkGray text-supportiveBlack placeholder:text-supportiveGray4 read-only:bg-supportiveDarkGray disabled:bg-supportiveThinGray block h-9 w-full appearance-none border bg-white px-4 text-base font-medium leading-tight placeholder:text-base focus:bg-white md:h-11 ${className}`
          )}
        />
        <button
          id={`toggle-${name}-visibility`}
          type="button"
          aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          onClick={togglePasswordVisibility}
          className="absolute ltr:right-3 rtl:left-3"
        >
          {isPasswordVisible ? <IconEyeClose /> : <IconEyeOpen />}
        </button>
      </div>
    </div>
  );
};

export default InputPassword;
